import React, { useState } from "react";
import classnames from "classnames";
import Context from "shared/util/Context";
import ProfileMenu from "./ProfileMenu";
import CarotIcon from "shared/components/svgs/carot.svg";

const ProfileButton = () => {
	const isAlist = Context.get("isAlist");
	const [isMenuOpen, toggleMenu] = useState(false);

	return (
		<div className="profile-button-container">
			<button
				className="profile-button"
				onClick={() => toggleMenu(!isMenuOpen)}
			>
				<div className="profile-button-inner-container">
					<div className="profile-button-details">
						<img
							className="profile-button-thumbnail"
							src={Context.get("thumbnail")}
							alt="profile pic"
						/>
						<div
							className={classnames("profile-button-name", {
								"profile-button-name-alist": isAlist,
								"profile-button-name-free": !isAlist,
							})}
						>
							{Context.get("displayname")}
						</div>
						{
							isAlist
								&& (
									<div className="profile-button-alist">
										A-LIST
									</div>
								)
						}
					</div>
					<CarotIcon
						className={classnames({
							"profile-button-carot-icon": isMenuOpen,
						})}
					/>
				</div>
			</button>
			<ProfileMenu isOpen={isMenuOpen} />
		</div>
	);
};

export default ProfileButton;



// WEBPACK FOOTER //
// ./src/shared/components/NavBar/ProfileButton.jsx